import React from "react";
import {
  Modal,
  List,
  Avatar,
  Tag,
  Button,
  Empty,
  Typography,
  Popconfirm,
  Tooltip,
} from "antd";
import {
  UserOutlined,
  ManOutlined,
  WomanOutlined,
  DisconnectOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const { Text } = Typography;

export function TherapistPatientsModal({
  visible,
  onClose,
  therapist,
  onUnlink,
}) {
  // "Cerrar" y "Cancelar" salen del bloque comun; el resto es de esta pantalla.
  const { t } = useTranslation(["patient", "common"]);

  const patients = therapist?.pacientes || [];

  const getGenderIcon = (sexo) =>
    sexo === "M" ? (
      <ManOutlined style={{ color: "#1890ff" }} />
    ) : sexo === "F" ? (
      <WomanOutlined style={{ color: "#eb2f96" }} />
    ) : (
      <UserOutlined />
    );

  return (
    <Modal
      title={t("asignados.tituloModal", {
        terapeuta: therapist?.firstname || "…",
      })}
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          {t("common:actions.close")}
        </Button>,
      ]}
      width={550}
      centered
      destroyOnHidden
    >
      {patients.length === 0 ? (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={t("asignados.sinUsuarios")}
        />
      ) : (
        <List
          itemLayout="horizontal"
          dataSource={patients}
          renderItem={(patient) => (
            <List.Item
              actions={[
                <Popconfirm
                  title={t("asignados.desvincularTitulo")}
                  // No se toca aqui, se reporta: convertirla en plantilla con
                  // hueco es reescribir la frase, no sustituirla.
                  description={t("asignados.desvincularConfirm", {
                    nombre: patient.name,
                  })}
                  onConfirm={() => onUnlink(therapist._id, patient._id)}
                  okText={t("asignados.desvincularOk")}
                  cancelText={t("common:actions.cancel")}
                  placement="left"
                >
                  <Tooltip title={t("asignados.desvincularTooltip")}>
                    <Button type="text" danger icon={<DisconnectOutlined />} />
                  </Tooltip>
                </Popconfirm>,
              ]}
            >
              <List.Item.Meta
                avatar={
                  <Avatar
                    src={patient.avatar}
                    icon={<UserOutlined />}
                    size="large"
                    style={{
                      backgroundColor: "#f0f2f5",
                      border: "1px solid #d9d9d9",
                    }}
                  />
                }
                title={
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 8 }}
                  >
                    <span style={{ fontWeight: 600 }}>
                      {patient.name} {patient.surname}
                    </span>
                    {getGenderIcon(patient.sexo)}
                  </div>
                }
                description={
                  <div style={{ display: "flex", gap: 8, marginTop: 4 }}>
                    {/* CAMBIO AQUÍ: Forzamos visualmente a "ACTIVO" siempre */}
                    <Tag color="success">{t("asignados.activo")}</Tag>

                    {patient.birthdate && (
                      <Text type="secondary" style={{ fontSize: 12 }}>
                        {new Date(patient.birthdate).getFullYear()}
                      </Text>
                    )}
                  </div>
                }
              />
            </List.Item>
          )}
        />
      )}
    </Modal>
  );
}
